<template>
  <footer :class="$style.footer">
    <div :class="$style.layout">
      <div :class="$style.logo">
        <img
          alt="Logo"
          src="@/base/assets/logos/logo-footer.svg"
          :class="$style.logoImg"
        >
      </div>
      <div :class="$style.nav">
        <nav>
          <BaseList :class="$style.menu">
            <BaseListItem>
              <BaseLink
                :class="$style.link"
                color="white"
                @click="clickDLPush('kontakt', 'linkclick'), navigateTo('contact')
                "
              >
                Kontakt
              </BaseLink>
            </BaseListItem>
            <BaseListItem>
              <BaseLink
                :class="$style.link"
                color="white"
                @click="clickDLPush('covid-19-infos', 'linkclick'), navigateTo('covid')
                "
              >
                COVID-19
              </BaseLink>
            </BaseListItem>
            <BaseListItem>
              <BaseLink
                :class="$style.link"
                color="white"
                url="https://www.istaexpress.de/impressum"
                external
                @click="clickDLPush('impressum', 'linkclickextern')"
              >
                Impressum
              </BaseLink>
            </BaseListItem>
            <!-- <BaseListItem>
              <BaseLink
                :class="$style.link"
                color="white"
                url="https://www.istaexpress.de/nutzungsbedingungen"
                external
                @click="clickDLPush('nutzungsbedingungen', 'linkclickextern')"
              >
                Nutzungsbedingungen
              </BaseLink>
            </BaseListItem> -->
            <BaseListItem>
              <BaseLink
                :class="$style.link"
                color="white"
                url="https://www.istaexpress.de/datenschutz"
                external
                @click="clickDLPush('datenschutzhinweise', 'linkclickextern')"
              >
                Datenschutzhinweise
              </BaseLink>
            </BaseListItem>
          </BaseList>
        </nav>
      </div>
      <div :class="$style.copy">
        <BaseText :class="$style.copyParagraph">
          © {{ getYear() }} ista Express Service GmbH
        </BaseText>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useDataLayerMixin } from '~/base/composables/useDataLayer'
import { useRouterNavigation } from '~/terminierungsportal/composables/useRouterNavigation'
import BaseList from '~/base/components/list/List.vue'
import BaseListItem from '~/base/components/list/ListItem.vue'
import BaseLink from '~/base/components/link/Link.vue'
import BaseText from '~/base/components/text/Text.vue'

const { formatDate } = useDate()

const { clickDLPush } = useDataLayerMixin()
const { navigateTo } = useRouterNavigation()

const getYear = (): string => {
  return formatDate(new Date(), 'YYYY')
}
</script>
<style module>
.footer {
  width: 100%;
  background-color: var(--color-blackcoral);
  padding: 36px 24px 20px 24px;
  grid-row-start: 2;
  grid-row-end: 3;

  @media screen and (min-width: 740px) {
    margin-top: 0;
    padding: 48px 24px 20px 24px;
  }
}

.layout {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.logo {
  border-bottom: 1px solid var(--color-grey4-15);
  width: 100%;
  padding: 0 0 36px 0;
  text-align: center;

  @media screen and (min-width: 740px) {
    border-bottom: 0;
    padding: 0;
  }
}

.logoImg {
  height: 70px;
  width: auto;

  @media screen and (min-width: 740px) {
    height: 55px;
  }
}

.nav {
  margin-top: 36.1px;

  @media screen and (min-width: 740px) {
    margin-top: var(--space-md);
  }
}

.copy {
  margin-top: var(--space-md);
}

.copyParagraph {
  color: var(--color-grey3);
  font-size: clamp(12px, 2vw, 14px);
  line-height: clamp(14px, 2vw, 16px);
  letter-spacing: 1px;
}

.menu {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
}

.link {
  font-size: clamp(14px, 2vw, 16px);
  line-height: clamp(17px, 2vw, 20px);
  letter-spacing: 0.08em;
  text-decoration: none;
  display: block;
  text-align: center;
  padding: 2px 0;

  &:hover,
  &:focus {
    text-decoration: underline;
    cursor: pointer
  }
}
</style>
